export default class Header {
    constructor(element) {
        this.element = element;
        this.options = {
            threshold: 0.01,
            alwaysShow: false,
            alwaysOpaque: false,
        };

        this.lastScrollPosition = 0;
        this.scrollPosition = 0;
        this.html = document.documentElement;

        this.initNavMobile();
        this.init();
    }

    init() {
        this.setOptions();
                    
        //if(!this.options.alwaysShow) {
            window.addEventListener('scroll', this.onScroll.bind(this));
        //}

        // AI CODE || Permet savoir si je suis sur une page en particulier
        if (window.location.pathname === "/index.html") {
            document.querySelector(".header").classList.remove("always-opaque");
        }
    }

    setOptions() {
        if ('alwaysShow' in this.element.dataset) {
            this.options.alwaysShow = true;
        }

        if('threshold' in this.element.dataset){
            this.options.threshold = Number(this.element.dataset.threshold);
        }
    }

    onScroll() {
        this.lastScrollPosition = this.scrollPosition;
        this.scrollPosition = document.scrollingElement.scrollTop;
        
        this.setHeaderState();
        this.setDirections();
    }

    setHeaderState() {
        if (this.scrollPosition > document.scrollingElement.scrollHeight * this.options.threshold) {
            this.html.classList.add('header-is-opaque');
        } else {
            this.html.classList.remove('header-is-opaque');
        }
    }

    setDirections() {
        if (this.scrollPosition >= this.lastScrollPosition){
            //Scroll ver le bas
            this.html.classList.add('is-scrolling-down');
            this.html.classList.remove('is-scrolling-up');
        } 
        else {
            //Scroll ver le haut 
        }
    }

    initNavMobile() {
        const toggle = this.element.querySelector('.js-toggle');
        toggle.addEventListener('click', this.onToggle.bind(this));
    }


    onToggle() {
        this.html.classList.toggle('nav-is-active');
    }

}